import { isCompletable, type GuideDefinition, type GuideStep } from './types';

/** Stable, collision-free id for persisting a step's manual completion. */
export function stableId(sectionId: string, step: GuideStep): string {
  return `${sectionId}.${step.id}`;
}

/**
 * Count completable steps and how many are done, combining server-derived facts
 * (autoDerived) with manual acknowledgements (completedSteps).
 */
export function computeProgress(
  def: GuideDefinition,
  autoDerived: Record<string, boolean> | undefined,
  completedSteps: string[]
): { total: number; done: number; pct: number } {
  const completed = new Set(completedSteps);
  let total = 0;
  let done = 0;
  for (const section of def.sections) {
    for (const step of section.steps) {
      if (!isCompletable(step)) continue;
      total += 1;
      const auto = Boolean(step.autoDeriveKey && autoDerived?.[step.autoDeriveKey]);
      if (auto || completed.has(stableId(section.id, step))) done += 1;
    }
  }
  const pct = total > 0 ? Math.round((done / total) * 100) : 0;
  return { total, done, pct };
}
